module.exports = "/fonts/ebilling-picturemark-d-0dcd7024d6a7cf8956f555e5a34b2462.svg";